import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ExpansionPanelComp from '../../common/ExpansionPanelComp';
import DatiModalitaPagamento from './sezione/DatiModalitaPagamento';

const styles = theme => ({
  root: {
    width: '100%',
  },
});
			
function ModalitaPagamentoPanel(props) {
	
  const { classes, isValida } = props;
  return (
    <div className={classes.root}> 
      <ExpansionPanelComp titolo={'modalitaPagamento'} componente={DatiModalitaPagamento} isValida={isValida} /> 
    </div>
  );
}

ModalitaPagamentoPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ModalitaPagamentoPanel);
